import { FC, useEffect, useState } from "react";

import edit from "../../../assets/edit.svg";
import { ICreateClubWizardForm } from "../../../common/interfaces/clubs-wizard.interface";
import "./BasicInfoPreview.scss";

import { ISocialNetwork } from "../../../common/interfaces/common.interface";
import { getSocialNetworkLinksAndIcons } from "../../../utilities/helpers";
import ExistingClubTag from "../ClubBasicInfo/ClubTags/ExistingClubTags/ExistingClubTag";

import { useFormikContext } from "formik";

interface BasicInfoPreviewInterface {
  changeStepHandler: () => void;
}

const BasicInfoPreview: FC<BasicInfoPreviewInterface> = (props) => {
  const [socialNetworkLinksAndIcons, setSocialNetworkLinksAndIcons] = useState<
    ISocialNetwork[]
  >([]);
  const { values } = useFormikContext<ICreateClubWizardForm>();
  useEffect(() => {
    const linksAndIcons: ISocialNetwork[] =
      getSocialNetworkLinksAndIcons(values);

    setSocialNetworkLinksAndIcons(linksAndIcons);
  }, []);

  return (
    <div className="basic-info-preview">
      <p className="basic-info-preview__header-description">
        These are your club settings. Take a final look before saving. Click on
        the edit button to change the configuration before saving.
      </p>
      <div className="basic-info-preview__content">
        <div className="basic-info-preview__header">
          <div className="basic-info-preview__header-wrapper">
            <div className="basic-info-preview__image">
              {values.clubImage && (
                <img src={values.clubImage} alt="User profile" />
              )}
            </div>
            <div className="basic-info-preview__name-email">
              <h3> {values.clubName}</h3>
              <p>{values.clubEmail}</p>
              <div className="basic-info-preview__social-networks">
                {socialNetworkLinksAndIcons.map((socialNetwork) => {
                  return (
                    <img
                      src={socialNetwork.socialNetworkIcon}
                      alt="social_network_icon"
                      key={socialNetwork.socialNetworkUrl}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <img onClick={props.changeStepHandler} src={edit} alt="edit" />
        </div>
        <p className="basic-info-preview__description">
          {values.clubDescription}
        </p>
        <div className="basic-info-preview__tags">
          {values.clubTags.map((tag) => {
            return <ExistingClubTag tagName={tag.label} key={tag.value} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default BasicInfoPreview;
